import React from 'react';

interface FooterProps {
 
  onOpenAdmin: () => void;
  isAdminRole: boolean;
}

export const Footer: React.FC<FooterProps> = ({ onOpenAdmin, isAdminRole }) => {

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 text-brand-grey p-4 border-t border-gray-200 flex justify-between items-center">
        <div>
            <p className="text-sm">
                &copy; {currentYear} One Size Fits None™. All Rights Reserved.
            </p>
        </div>
      <div className="flex items-center space-x-4">
        {isAdminRole && (
          <>
            <button
              onClick={onOpenAdmin}
              className="flex items-center space-x-2 text-sm text-gray-600 hover:text-brand-orange transition-colors"
              aria-label="Open admin console"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 9a3 3 0 100-6 3 3 0 000 6zM6 8a2 2 0 11-4 0 2 2 0 014 0zM1.49 15.326a.78.78 0 01-.358-.442 3 3 0 014.308-3.516 6.484 6.484 0 00-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 01-2.07-.655zM16.44 15.98a4.97 4.97 0 002.071.655A.78.78 0 0019.51 15c.039-.212.048-.432.025-.654a6.484 6.484 0 00-1.905-3.96 3 3 0 004.308 3.516.78.78 0 00-.358.442zM13 14.5a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Admin Console</span>
            </button>
            <span className="text-gray-300">|</span>
          </>
        )}
        
          
      </div>
    </footer>
  );
};